'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
* This source code is quoted from rc-menu.
* homepage: https://github.com/react-component/menu
*/
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var placements = exports.placements = {
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};

exports["default"] = placements;


//////////////////
// WEBPACK FOOTER
// ./~/bee-menus/build/placements.js
// module id = 392
// module chunks = 0